import { useEffect, useState } from "react";

// Pentest durations for the logged-in participant, from the server (their
// assignment, else the environment default PENTEST_*_MINUTES). Use this instead
// of hardcoding minutes in on-screen text.
const FALLBACK = { mandatory: null, extra: null };

const useStudyTiming = () => {
  const [timing, setTiming] = useState(FALLBACK);
  useEffect(() => {
    let alive = true;
    const token = localStorage.getItem("access_token");
    if (!token) return undefined;
    fetch("/api/player/timing", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive && d) {
          setTiming({ mandatory: d.pentest_mandatory_minutes, extra: d.pentest_extra_minutes });
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return timing;
};

export default useStudyTiming;
